import _ from "lodash";

const helpers = {
  calulateNextMonth,
  calculateSeries,
  solveFor,
};

const state = {
  strings: {
    tableHeaders: [
      "Month",
      "Budget",
      "CPS ($)",
      "Sign-Ups",
      "Percentage of Organic Sign-ups (%)",
      "Sign-Ups Organic",
      "Sign-Ups Total",
      "Free trail to subs. rate (%)",
      "New Subs from Sign-Ups",
      "Average Monthly Churn Rate (%)",
      "Monthly Churn (actual)",
      "Subscribers",
    ],
  },
  uiState: {
    pickedField: "totalBudget",
    solvedNumber: -100,
  },
  params: {
    trialConversion: 50,
    monthlyChurn: 10,
    monthlyCPS: 15,
    monthlySignUpsOrganic: 25,
    totalBudget: 100000,
    monthCount: 10,
    startingSubscribers: 0,
    endingSubscribers: 0,
  },
  defaults: {
    name: "Churn",
    monthlyTrialConversion: 50,
    currency: "USD",
    monthlyChurn: 10,
    monthlyCPS: 15,
    monthlySignUpsOrganic: 25,
    monthlyBudget: 100000,
    monthCount: 10,
    startingSubscribers: 0,
    endingSubscribers: 0,
  },
};

const actions = {
  updateParams({ commit }, params) {
    commit("UPDATE_PARAMS_VALUES", params);
  },
  solveFor({ state, commit }, field) {
    let val = solveFor(state.params, field, state.params.endingSubscribers);
    commit("UPDATE_SOLVE", { val, field });
  },
};
const mutations = {
  UPDATE_PARAMS_VALUES: (state, data) => {
    _.forOwn(data, (val, key) => {
      state.params[key] = parseFloat(val);
    });
  },
  UPDATE_SOLVE: (state, data) => {
    state.uiState.solvedNumber = data.val;
  },
};
const getters = {
  getParams: (state) => {
    return state.params;
  },
  getUiState: (state) => {
    return state.uiState;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  helpers,
  getters,
};

function calulateNextMonth(params, lastSubscribers) {
  let plannedSignups =
    params.totalBudget / params.monthCount / params.monthlyCPS;
  let signUps = plannedSignups;
  let signUpsOrganic = plannedSignups * (params.monthlySignUpsOrganic / 100);
  let totalSignups = signUps + signUpsOrganic;

  let trialConversionPercent = params.trialConversion;
  let newSubs = (totalSignups * trialConversionPercent) / 100;

  let monthlyChurn = Number.parseFloat(params.monthlyChurn);
  let subscribers = newSubs + (lastSubscribers * (100 - monthlyChurn)) / 100;
  return subscribers;
}

function calculateSeries(params) {
  let totalMonths = params.monthCount;
  let subs = params.startingSubscribers;
  while (totalMonths > 0) {
    subs = calulateNextMonth(params, subs);
    totalMonths--;
  }
  return subs;
}

function solveFor(params, field, endingSubscribers) {
  let closestPair = {
    fieldValue: -100000,
    eSValue: -1000000,
  };

  let step = 0.01;
  let min = -500;
  let max = 500;
  if (field == "totalBudget") {
    step = 100;
    min = 0;
    max = 10000000;
  }
  let val = min;
  while (val < max) {
    let par = _.cloneDeep(params);
    par[field] = val;
    let stepResult = calculateSeries(par);
    if (
      Math.abs(stepResult - endingSubscribers) <
      Math.abs(closestPair.eSValue - endingSubscribers)
    ) {
      closestPair.fieldValue = val;
      closestPair.eSValue = stepResult;
    }
    val += step;
  }

  return closestPair.fieldValue;
}
